import React, {ChangeEvent, useEffect, useState} from "react"
import InputMask from 'react-input-mask';
import classes from "./Input.module.scss"

interface InputProps {
  name: string,
  className?: string
  required?: boolean
  type?: string
  label?: string
  value: string
  shouldValidate?: boolean
  placeholder?: string
  onChange?: any
  onInput?: any
  onPaste?: any
  touched?: boolean
  theme?: 'animate' | 'default' | 'field'
  valid?: boolean
  errorMessage?: string
  autoFocus?: boolean
  autoComplete?: string
  mask?: string
  passwordNote?: string
  disabled?: boolean
}

export default function Input({
    className,
    required = false,
    type,
    label,
    value,
    shouldValidate,
    touched,
    theme = 'animate',
    valid,
    errorMessage,
    mask,
    passwordNote,
    disabled,
    ...rest
  }: InputProps) {

  const [passwordShow, setPasswordShow] = useState(true)
  const [active, setActive] = useState(false)
  const initialType = type || 'text'
  const inputType = initialType === 'password' ? (passwordShow ? 'password' : 'text') : initialType

  useEffect(() => {
    if (value) {
      setTimeout(() => {
        setActive(true)
      })
    } else {
      setTimeout(() => {
        setActive(false)
      })
    }
  }, [value])

  const cls = [classes.wrap]
  cls.push(classes[theme])

  if (className) {
    cls.push(className)
  }

  if (disabled) {
    cls.push(classes.disabled)
  }

  if (!valid && shouldValidate)
    cls.push(classes.error)

  if (required) {
    cls.push(classes.required)
  }

  const id = `${initialType}-${Math.random()}`
  const labelTemplate = label ? <label htmlFor={id}>{label}</label> : null

  const eyeButton = initialType === 'password' && (
    <span
      className={[classes.eye_button, !passwordShow ? classes.eye_button_active : ''].join(" ")}
      onClick={() => setPasswordShow(!passwordShow)}
    />
  );

  const errorMessageTemplate = errorMessage && <span className={classes.error_message}>{errorMessage}</span>
  const passwordNoteTemplate = passwordNote && <div className={classes.password_note}>{passwordNote}</div>

  const activityHandler = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.type === 'focus') setActive(true)
    if (e.type === 'blur' && !value) setActive(false)
  }

  const inputTemplate =
    mask ? (
      <InputMask
        value={value}
        mask={mask}
        onFocus={activityHandler}
        onBlur={activityHandler}
        disabled={disabled}
        {...rest}
      />
    ) : (
      <input
        type={inputType}
        value={value}
        onFocus={activityHandler}
        onBlur={activityHandler}
        disabled={disabled}
        {...rest}
      />
    )

  return (
    <div className={cls.join(" ")}>
      <div className={[classes.container, active ? classes.container_active : ''].join(" ")}>
        {labelTemplate}
        {inputTemplate}
        {eyeButton}
      </div>
      {errorMessageTemplate}
      {passwordNoteTemplate}
    </div>
  )
}